/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The nearest-neighbor method is the most accurate for oligonucleotides because it accounts for the identity of neighbouring bases, not just the overall GC content. It is the headline value here.`)
};

const es_tm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El método de vecino más cercano es el más preciso para oligonucleótidos porque tiene en cuenta la identidad de las bases vecinas, no solo el contenido GC general. Es el valor principal aquí.`)
};

const de_tm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Nearest-Neighbor-Methode ist für Oligonukleotide am genauesten, da sie die Identität benachbarter Basen berücksichtigt, nicht nur den gesamten GC-Gehalt. Sie ist hier der Hauptwert.`)
};

const nl_tm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De nearest-neighbor-methode is het nauwkeurigst voor oligonucleotiden omdat deze rekening houdt met de identiteit van naburige basen, niet alleen het algehele GC-gehalte. Dit is hier de hoofdwaarde.`)
};

const fr_tm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La méthode des plus proches voisins est la plus précise pour les oligonucléotides car elle tient compte de l'identité des bases voisines, pas seulement du contenu GC global. C'est la valeur principale ici.`)
};

const it_tm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il metodo dei vicini più prossimi è il più accurato per gli oligonucleotidi perché tiene conto dell'identità delle basi vicine, non solo del contenuto GC complessivo. È il valore principale qui.`)
};

const pt_br2_tm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O método do vizinho mais próximo é o mais preciso para oligonucleotídeos porque leva em conta a identidade das bases vizinhas, não apenas o conteúdo geral de GC. É o valor principal apresentado aqui.`)
};

const pt_tm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O método do vizinho mais próximo é o mais preciso para oligonucleótidos porque tem em conta a identidade das bases vizinhas, não apenas o conteúdo global de GC. É o valor principal apresentado aqui.`)
};

const ja_tm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近接塩基対法は、全体のGC含量だけでなく隣接塩基の同一性も考慮するため、オリゴヌクレオチドにとって最も正確です。ここでは主な値として使用されています。`)
};

const zh_tm_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近邻法对寡核苷酸最为准确，因为它考虑了相邻碱基的具体身份，而不仅仅是整体 GC 含量。这是本工具给出的主要结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_faq_a1", locale)
	if (locale === "en") return en_tm_faq_a1(inputs)
	if (locale === "es") return es_tm_faq_a1(inputs)
	if (locale === "de") return de_tm_faq_a1(inputs)
	if (locale === "nl") return nl_tm_faq_a1(inputs)
	if (locale === "fr") return fr_tm_faq_a1(inputs)
	if (locale === "it") return it_tm_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_tm_faq_a1(inputs)
	if (locale === "pt") return pt_tm_faq_a1(inputs)
	if (locale === "ja") return ja_tm_faq_a1(inputs)
	return zh_tm_faq_a1(inputs)
};